import { render, staticRenderFns } from "./RegiaoList.vue?vue&type=template&id=208e1e82&scoped=true"
import script from "./RegiaoList.vue?vue&type=script&lang=js"
export * from "./RegiaoList.vue?vue&type=script&lang=js"
import style0 from "./RegiaoList.vue?vue&type=style&index=0&id=208e1e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e1e82",
  null
  
)

export default component.exports